import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="container-x py-32 text-center">
      <span className="eyebrow">404</span>
      <h1 className="mt-4 h-display text-5xl">Page not found</h1>
      <p className="mt-4 text-brand-sage">The page you're after has moved or never existed.</p>
      <Link to="/" className="btn-primary mt-8">Back to home</Link>
    </div>
  );
}
